module.exports = __webpack_public_path__ + "img/terra.16adfe56.png";